import type { QueryClient } from '@tanstack/react-query';
import { environmentKeys } from './entity';

/** Refetch every account's workspace list, after a workspace is added, renamed or removed. */
export function invalidateEnvironmentLists(qc: QueryClient): Promise<void> {
  return qc.invalidateQueries({ queryKey: environmentKeys.accountLists() });
}
